import React from 'react';
import { ListFieldSection, SectionGroup, FieldSet, PageSection } from '../../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../../Core/InjectedPropsContext';
import { Checkbox, Field, TextOutput, Label } from '../../../../../Core';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import {
  LiquidLimitEquipmentDetailsSection,
  LiquidLimitMethodBTrialSection,
} from 'Components/Worksheets/AtterbergLimitWorksheet/Aashto/Sections';
import { useSelector } from 'react-redux';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';

let LiquidLimitMethodBPageSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );

  return (
    <PageSection heading="Liquid Limit">
      <NamePrefixModifier appendNamePrefix="LiquidLimit">
        <LiquidLimitEquipmentDetailsSection />
        <SectionGroup heading="Liquid Limit Determination">
          <ListFieldSection>
            <FieldSet>
              <Label>Material Suitability</Label>
              <Field input={<Checkbox />} label="Result cannot be obtained" name="NonPlastic" />
            </FieldSet>
          </ListFieldSection>
          {determinationPerformed && <LiquidLimitMethodBTrialSection />}
        </SectionGroup>
      </NamePrefixModifier>
      <ListFieldSection heading="Result">
        <Field input={<TextOutput />} label="Liquid Limit" name="Results.LiquidLimitText" />
      </ListFieldSection>
    </PageSection>
  );
};

LiquidLimitMethodBPageSection = withInjectedProps(LiquidLimitMethodBPageSection);

export { LiquidLimitMethodBPageSection };
export default LiquidLimitMethodBPageSection;
